(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

// import Helper from './modules/helper';
// const helper = new Helper();
document.addEventListener('DOMContentLoaded', function (params) {
  var paymentResQueryParam = {
    token: getParameterByName("token"),
    type: getParameterByName("type"),
    status: getParameterByName("status"),
    transaction: getParameterByName("trasaction"),
    referenceNumber: getParameterByName("referencenumber")
  };

  if (typeof paymentResQueryParam !== 'undefined' && paymentResQueryParam !== null && paymentResQueryParam !== '' && typeof paymentResQueryParam['status'] !== 'undefined' && paymentResQueryParam['status'] !== null && paymentResQueryParam['status'] !== '') {
    if (paymentResQueryParam['status'] === 'success') {
      var transaction = typeof paymentResQueryParam['transaction'] !== 'undefined' && paymentResQueryParam['transaction'] !== null ? paymentResQueryParam['transaction'] : "";

      switch (transaction.toUpperCase()) {
        case "MOVEIN":
          debugger;
          window.opener.paymentStatusMoveInCallback(paymentResQueryParam);
          break;

        case "RESERVATION":
          window.opener.paymentStatusReserveCallback(paymentResQueryParam);
          break;

        case "USER-PAYMENT":
          window.opener.paymentStatusUserPayCallback(paymentResQueryParam);
          break;

        case "USER-ADD-CARD":
          window.opener.paymentStatusAddCardCallback(paymentResQueryParam);
          break;

        default:
          document.getElementById('six-storage-success-container-ptwofour').style.display = 'none';
          document.getElementById('six-storage-failed-container-ptwofour').style.display = 'block';
      }

      document.getElementById('six-storage-success-container-ptwofour').style.display = 'block';
      document.getElementById('six-storage-failed-container-ptwofour').style.display = 'none';
    } else {
      var _transaction = typeof paymentResQueryParam['transaction'] !== 'undefined' && paymentResQueryParam['transaction'] !== null ? paymentResQueryParam['transaction'] : "";

      switch (_transaction.toUpperCase()) {
        case "MOVEIN":
          debugger;
          window.opener.paymentStatusMoveInCallback(paymentResQueryParam);
          break;

        case "RESERVATION":
          window.opener.paymentStatusReserveCallback(paymentResQueryParam);
          break;

        case "USER-PAYMENT":
          window.opener.paymentStatusUserPayCallback(paymentResQueryParam);
          break;

        case "USER-ADD-CARD":
          window.opener.paymentStatusAddCardCallback(paymentResQueryParam);
          break;

        default:
          document.getElementById('six-storage-success-container-ptwofour').style.display = 'none';
          document.getElementById('six-storage-failed-container-ptwofour').style.display = 'block';
      }

      document.getElementById('six-storage-success-container-ptwofour').style.display = 'none';
      document.getElementById('six-storage-failed-container-ptwofour').style.display = 'block';
    }

    setTimeout(function () {
      window.close();
    }, 6000); // }
    // else {
    //     document.getElementById('six-storage-success-container-ptwofour').style.display = 'none';
    //     document.getElementById('six-storage-failed-container-ptwofour').style.display = 'block';
    //     setTimeout(() => {
    //         window.close();
    //     }, 1500);
    // }
  }
});

var getParameterByName = function getParameterByName(name) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
  debugger;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

},{}]},{},[1]);
